var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_64912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3721 2.3313V50.9842C38.0678 50.669 38.7473 50.3249 39.4105 49.9519V3.36432C38.7478 2.99241 38.0683 2.64807 37.3721 2.3313Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1792 0V53.3163C27.8656 53.2991 28.5451 53.2557 29.2176 53.186V0.1303C28.543 0.060599 27.8636 0.0171651 27.1792 0Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9617 36.9316C52.3073 33.6758 53.0001 30.1845 53.0001 26.6583C53.0001 23.1322 52.3073 19.6408 50.9617 16.385V36.9316Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7864 0.1303V53.186C24.4583 53.2557 25.1378 53.2991 25.8248 53.3163V0C25.1378 0.0171651 24.4583 0.060599 23.7864 0.1303Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5896 3.36432V49.9519C14.2523 50.3238 14.9317 50.6679 15.628 50.9842V2.3313C14.9323 2.64703 14.2528 2.99137 13.5896 3.36432Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9871 1.76189V51.5547C17.6539 51.8148 18.3333 52.0462 19.0255 52.2491V1.06592C18.3338 1.27138 17.6544 1.50337 16.9871 1.76189Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.385 0.705334V52.611C21.057 52.7702 21.7364 52.9036 22.4234 53.0112V0.302734C21.7349 0.410926 21.0554 0.545126 20.385 0.705334Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04098e-05 26.6583C-0.00433548 30.1849 0.688582 33.6771 2.03842 36.9316V16.385C0.688642 19.6395 -0.00427347 23.1317 2.04098e-05 26.6583Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39453 13.5861V39.7301C4.00064 40.8139 4.68179 41.8534 5.43293 42.8409V10.4753C4.68214 11.4631 4.00101 12.5026 3.39453 13.5861Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79517 8.82848V44.4851C7.43755 45.2036 8.11801 45.8868 8.83357 46.5316V6.78271C8.11783 7.42702 7.43735 8.10995 6.79517 8.82848Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1919 5.63795V47.6791C10.8478 48.1941 11.5273 48.6786 12.2303 49.1327V4.18359C11.5278 4.63613 10.8484 5.12091 10.1919 5.63795Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1665 6.78271V46.5347C44.8821 45.8899 45.5625 45.2068 46.2049 44.4882V8.8316C45.5628 8.11201 44.8823 7.42804 44.1665 6.78271Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7664 4.18359V49.1327C41.4688 48.6802 42.1483 48.1957 42.8048 47.6791V5.63795C42.1509 5.12195 41.4714 4.63717 40.7664 4.18359Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5642 10.4753V42.8409C48.3164 41.8535 48.9986 40.814 49.6057 39.7301V13.5861C48.9982 12.5025 48.3161 11.463 47.5642 10.4753Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9744 1.06738V52.2505C34.666 52.0461 35.3454 51.8147 36.0128 51.5561V1.76179C35.346 1.50379 34.6665 1.27232 33.9744 1.06738Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 0.302734V53.0112C31.2652 52.9041 31.9446 52.7707 32.6151 52.611V0.705334C31.9452 0.546167 31.2657 0.411967 30.5767 0.302734Z",
    fill: "#FFFE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6282 9.16923V57.8221C16.0748 58.0239 16.5278 58.214 16.9874 58.3924V8.59888C16.5284 8.77677 16.0753 8.96689 15.6282 9.16923Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4233 7.14304V59.8484C22.8725 59.9186 23.3256 59.9772 23.7825 60.024V6.96826C23.3256 7.01456 22.8725 7.07281 22.4233 7.14304Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0256 7.90524V59.0884C19.4738 59.2205 19.9269 59.3409 20.3848 59.4496V7.54321C19.9269 7.65193 19.4738 7.7726 19.0256 7.90524Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03833 23.2228V43.7694C2.43574 44.7288 2.88854 45.6641 3.39442 46.5704V20.4241C2.88847 21.3295 2.43567 22.264 2.03833 23.2228Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 6.82935C26.2728 6.82935 26.0464 6.82935 25.8208 6.83793V60.1542C26.0467 60.16 26.2731 60.1628 26.5 60.1628C26.7269 60.1628 26.9533 60.16 27.1792 60.1542V6.83793C26.9536 6.83169 26.7272 6.82935 26.5 6.82935Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2336 11.0216V55.9707C12.6782 56.2563 13.1312 56.5291 13.5928 56.7892V10.2024C13.1292 10.4625 12.6761 10.7356 12.2336 11.0216Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8335 13.6197V53.3717C9.27338 53.7681 9.72618 54.1496 10.1919 54.5163V12.4744C9.7267 12.8416 9.2739 13.2234 8.8335 13.6197Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43604 17.3118V49.6789C5.86713 50.2459 6.3202 50.7949 6.79523 51.326V15.6655C6.32071 16.1961 5.86765 16.7448 5.43604 17.3118Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2048 15.6655V51.3299C46.6794 50.7993 47.1324 50.2503 47.564 49.6828V17.3118C47.1329 16.7448 46.6799 16.1961 46.2048 15.6655Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8081 12.4744V54.5163C43.2733 54.1522 43.7261 53.7707 44.1665 53.3717V13.6197C43.7266 13.2234 43.2738 12.8416 42.8081 12.4744Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6055 20.4241V46.5704C50.1123 45.6649 50.5662 44.7304 50.9647 43.7717V23.2228C50.5663 22.2639 50.1125 21.3294 49.6055 20.4241Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2175 6.96753V60.0232C29.6745 59.9764 30.1275 59.9179 30.5767 59.8477V7.14308C30.1281 7.07286 29.675 7.01434 29.2175 6.96753Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6152 7.54321V59.4481C33.0732 59.3394 33.5263 59.219 33.9744 59.0868V7.90368C33.5263 7.77208 33.0732 7.65193 32.6152 7.54321Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4104 10.2024V56.7915C39.872 56.5315 40.3251 56.2586 40.7696 55.9731V11.0216C40.3256 10.7356 39.8725 10.4625 39.4104 10.2024Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0127 8.59888V58.3924C36.4717 58.2146 36.9248 58.0244 37.3719 57.8221V9.16923C36.9253 8.96741 36.4722 8.77729 36.0127 8.59888Z",
    fill: "#EA4E8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0127 15.4392V65.2328C36.4717 65.0549 36.9248 64.8648 37.3719 64.6624V16.0072C36.9253 15.8054 36.4722 15.6161 36.0127 15.4392Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6282 16.0072V64.6601C16.0748 64.8624 16.5278 65.0525 16.9874 65.2304V15.4392C16.5284 15.6155 16.0753 15.8049 15.6282 16.0072Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4233 13.9809V66.6863C22.8725 66.7565 23.3256 66.8151 23.7825 66.8619V13.8062C23.3256 13.8545 22.8725 13.9128 22.4233 13.9809Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0256 14.7424V65.9255C19.4738 66.0582 19.9269 66.1789 20.3848 66.2876V14.3804C19.9269 14.4896 19.4738 14.6103 19.0256 14.7424Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03833 30.0599V50.6065C2.43567 51.5653 2.88847 52.4998 3.39442 53.4052V27.2612C2.88862 28.1668 2.43582 29.1012 2.03833 30.0599Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 13.6665C26.2731 13.6665 26.0467 13.6694 25.8208 13.6751V66.9914C26.0464 66.9976 26.2728 67 26.5 67C26.7272 67 26.9536 67 27.1792 66.9914V13.6751C26.9539 13.6699 26.7274 13.667 26.5 13.6665Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2336 17.858V62.8071C12.6782 63.0937 13.1312 63.3668 13.5928 63.6263V17.0403C13.1292 17.2993 12.6761 17.5719 12.2336 17.858Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8335 20.4576V60.2096C9.27338 60.6059 9.72618 60.9875 10.1919 61.3542V19.313C9.7267 19.6792 9.2739 20.0607 8.8335 20.4576Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43604 24.1505V56.5161C5.86713 57.0841 6.3202 57.6331 6.79523 58.1632V22.5066C6.32071 23.0351 5.86765 23.5831 5.43604 24.1505Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2048 22.5034V58.16C46.6794 57.63 47.1324 57.0809 47.564 56.5129V24.1505C47.1329 23.5835 46.6799 23.0345 46.2048 22.5034Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8081 19.313V61.3542C43.2733 60.9875 43.7261 60.6059 44.1665 60.2096V20.4576C43.7266 20.0612 43.2738 19.6797 42.8081 19.313Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6055 27.2612V53.4052C50.1125 52.4998 50.5663 51.5653 50.9647 50.6065V30.0599C50.5662 29.1012 50.1123 28.1667 49.6055 27.2612Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2175 13.8054V66.8611C29.6745 66.8143 30.1275 66.7558 30.5767 66.6856V13.981C30.1281 13.9128 29.675 13.8543 29.2175 13.8054Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6152 14.3804V66.286C33.0732 66.1773 33.5263 66.0566 33.9744 65.924V14.7408C33.5263 14.6103 33.0732 14.4901 32.6152 14.3804Z",
    fill: "#E85EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4104 17.0403V63.6271C39.872 63.367 40.3251 63.0939 40.7696 62.8079V17.858C40.3256 17.5729 39.8725 17.3004 39.4104 17.0403Z",
    fill: "#E85EF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_64912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 67,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewo);
export default __webpack_public_path__ + "static/media/newo.3095e53504349f0e7621d6a14a625197.svg";
export { ForwardRef as ReactComponent };